import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class DateDef {
  key?: string = uuid()
  type: 'date' = 'date'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: DateOptions = new DateOptions()
  rules?: Rule[]
}

export class DateOptions {
  defaultValue?: string | string[] // 根据类型不同而不同
  type?: 'date' | 'datetime' | 'datetimerange' | 'daterange' | 'year' | 'month' = 'date' // 暂只支持部分
  clearable?: boolean = true
  disabled?: DisabledType = false
  labelWidth?: string | number
  required?: boolean = false
  format?: string
  placeholder?: string
  disabledDate?: (params: {form: any; rowForm: any}) => (date: Date) => boolean
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
}
